import PropTypes from 'prop-types';
import Body from 'commons/card/Body';
import CollapsableCard from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import React from 'react';

export default function EmptyResult(props) {
  return (
    <CollapsableCard type="none" canCollapse={false}>
      <Header title={props.title}></Header>
      <Body>
        <span className="k-input-icon">
          <span className="k-icon k-font-icon k-i-information" />
        </span>
        <span>{props.message}</span>
      </Body>
    </CollapsableCard>
  );
}

EmptyResult.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
};
